import Link from "@/components/link/Link";
import { SEO_TRACK, SEO_URL } from "@/constants/horseRacing";

const oddsLink = (
  <Link next={false} href={SEO_URL[SEO_TRACK.PIMLICO].ODDS}>
    Preakness Stakes Odds
  </Link>
);

const bettingLink = (
  <Link next={false} href={SEO_URL[SEO_TRACK.PIMLICO].BETTING}>
    Preakness Stakes Betting
  </Link>
);

const PreaknessStakesSeo = () => (
  <div>
    The 150th Preakness Stakes takes place on Saturday, May 17th, at Pimlico
    Race Course in Baltimore, and bettors are zeroing in on the action. Track
    the latest {oddsLink}, dive into expert {bettingLink} analysis, and get
    ready for the second jewel of the Triple Crown.
  </div>
);

export default PreaknessStakesSeo;
